/**
 * CMS-typed fallback page-level content for the add-ons selection page.
 *
 * Keyed by SessionTypeKey. The CMS is the source of truth; this record
 * provides a safety net when CMS content is missing for a session type.
 * Theme and image positioning are derived from the session type key
 * at assembly time via `deriveAddOnsTheme` / `deriveAddOnsImagePosition`.
 */
import type { SessionTypeKey } from '@/stores/sessionType'
import { SessionType } from '@/stores/sessionType'

import type {
  AddOnsSelectionPage,
  BookingUpgradeModal,
  ContentRef
} from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

const sharedFields = {
  internalName: '',
  identifier: '',
  subtitle: '',
  backButtonLabel: '',
  ctaLabel: '',
  validationErrorMessage: '',
  hairAndMakeupUpgradeLabel: '',
  hairAndMakeupUpgradeLabelMobile: '',
  hairMakeupIncludedLabel: '',
  // Continue-CTA upgrade-intercept ref — null until Marketing authors a
  // CMS entry and links it (Elite / Elite Plus tiers). The TypeGen
  // emitter doesn't translate the C# `?` nullability marker into TS
  // optional, so the cast is the pragmatic shim until that's fixed.
  continueUpgradeModal: null as unknown as ContentRef<BookingUpgradeModal>,
  upgradeSuccessToastTemplate: ''
}

export const addOnsPageFallbacks: Partial<Record<SessionTypeKey, AddOnsSelectionPage>> = {
  [SessionType.EliteUnlimited]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.ElitePlus]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.Elite]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.MostPopular]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.Legacy]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.Standard]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.Simple]: {
    heading: '',
    ...sharedFields
  },
  [SessionType.Basic]: {
    heading: '',
    ...sharedFields
  }
}
